import { Card, Form, Input, Button, Typography, Alert, Result } from 'antd';
import { MailOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authApi } from '../../../api/auth.api';

const { Text } = Typography;

const AuthCard = ({ children }) => (
  <div style={{
    minHeight: '100vh',
    background: 'linear-gradient(135deg, var(--wl-primary-pale) 0%, var(--wl-bg) 50%, var(--wl-primary-pale) 100%)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24,
  }}>
    <div style={{ position: 'fixed', top: -80, right: -80, width: 300, height: 300, borderRadius: '50%', background: 'rgba(77,184,71,0.15)', pointerEvents: 'none' }} />
    <div style={{ position: 'fixed', bottom: -60, left: -60, width: 220, height: 220, borderRadius: '50%', background: 'rgba(255,255,255,0.08)', pointerEvents: 'none' }} />
    <Card
      bordered={false}
      style={{ width: 440, borderRadius: 24, boxShadow: '0 24px 80px rgba(0,0,0,0.25)', overflow: 'hidden', border: 'none' }}
      styles={{ body: { padding: 0 } }}
    >
      {/* Logo header */}
      <div style={{ background: 'var(--wl-primary-pale)',  textAlign: 'center' }}>
        <img
          src="/logo/WECIRCLE_LOGO with Leaf.svg"
          alt="WeLittle"
          style={{ maxHeight: 110, maxWidth: 220, objectFit: 'contain'}}
          onError={(e) => { e.currentTarget.style.display = 'none'; }}
        />
        {/* <p style={{ marginTop: 10, color: 'rgba(255,255,255,0.80)', fontSize: 13, letterSpacing: 0.3 }}>
          WeCircle
        </p> */}
      </div>
      {children}
    </Card>
  </div>
);

const ForgotPassword = () => {
  const [loading,   setLoading]   = useState(false);
  const [sent,      setSent]      = useState(false);
  const [sentEmail, setSentEmail] = useState('');
  const [errorMsg,  setErrorMsg]  = useState('');
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const handleSubmit = async ({ email }) => {
    setLoading(true);
    setErrorMsg('');
    try {
      await authApi.forgotPassword({ email });
      setSentEmail(email);
      setSent(true);
    } catch (err) {
      setErrorMsg(err.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <AuthCard>
        <div style={{ padding: '40px 40px 32px' }}>
          <Result
            status="success"
            icon={
              <div style={{
                width: 72, height: 72, borderRadius: '50%',
                background: 'linear-gradient(135deg,var(--wl-primary-light),var(--wl-primary))',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                margin: '0 auto 16px',
              }}>
                <MailOutlined style={{ fontSize: 32, color: '#fff' }} />
              </div>
            }
            title={<span style={{ color: 'var(--wl-text)', fontSize: 20, fontWeight: 700 }}>Check your inbox</span>}
            subTitle={
              <span style={{ color: '#666', fontSize: 14, lineHeight: 1.7 }}>
                We sent a password reset link to<br />
                <strong style={{ color: 'var(--wl-primary)' }}>{sentEmail}</strong><br />
                The link expires in <strong>1 hour</strong>.
              </span>
            }
          />
          <Button
            block
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate('/login')}
            style={{ borderRadius: 9999, height: 44, fontWeight: 600, borderColor: 'var(--wl-primary)', color: 'var(--wl-primary)' }}
          >
            Back to Login
          </Button>
          <div style={{ textAlign: 'center', marginTop: 14 }}>
            <Text style={{ fontSize: 12, color: 'var(--wl-text-muted)' }}>
              Didn't receive it?{' '}
              <span
                style={{ color: 'var(--wl-primary)', cursor: 'pointer', fontWeight: 600 }}
                onClick={() => setSent(false)}
              >
                Try again
              </span>
            </Text>
          </div>
        </div>
      </AuthCard>
    );
  }

  return (
    <AuthCard>
      <div style={{ padding: '36px 40px 28px' }}>
        <p style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: 20, color: 'var(--wl-primary)', marginBottom: 6 }}>
          Forgot Password?
        </p>
        <p style={{ fontSize: 13, color: '#888', marginBottom: 28, lineHeight: 1.6 }}>
          Enter your account email and we'll send you a link to reset your password.
        </p>

        {errorMsg && (
          <Alert
            type="error"
            message={errorMsg}
            showIcon
            style={{ borderRadius: 10, marginBottom: 20 }}
            closable
            onClose={() => setErrorMsg('')}
          />
        )}

        <Form form={form} layout="vertical" onFinish={handleSubmit} size="large">
          <Form.Item
            name="email"
            label="Email Address"
            rules={[
              { required: true, message: 'Please enter your email' },
              { type: 'email',  message: 'Please enter a valid email' },
            ]}
          >
            <Input
              prefix={<MailOutlined style={{ color: 'var(--wl-text-muted)' }} />}
              placeholder="Enter your account email"
              style={{ borderRadius: 12 }}
              onChange={() => errorMsg && setErrorMsg('')}
            />
          </Form.Item>

          <Form.Item style={{ marginBottom: 8 }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              style={{
                height: 48, borderRadius: 9999, fontSize: 15,
                fontFamily: "'Fredoka One',sans-serif", letterSpacing: 0.5,
                background: 'linear-gradient(181deg,var(--wl-primary-light) 0%,var(--wl-primary) 100%)',
                border: 'none', boxShadow: '0 6px 20px rgba(var(--wl-primary-rgb),0.4)',
              }}
            >
              Send Reset Link
            </Button>
          </Form.Item>
        </Form>

        <div style={{ textAlign: 'center', marginTop: 16 }}>
          <span
            style={{ fontSize: 13, color: 'var(--wl-primary)', cursor: 'pointer', fontWeight: 600 }}
            onClick={() => navigate('/login')}
          >
            <ArrowLeftOutlined style={{ marginRight: 4 }} />
            Back to Login
          </span>
        </div>

        <div style={{ textAlign: 'center', marginTop: 20 }}>
          <Text style={{ fontSize: 11, color: 'var(--wl-text-muted)' }}>
            &copy; {new Date().getFullYear()} WeCircle
          </Text>
        </div>
      </div>
    </AuthCard>
  );
};

export default ForgotPassword;
